module.exports = __webpack_public_path__ + "img/Safeheron.ccf6ca42.png";